import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
// import SpeakerVideo from '../../elements/video/SpeakerVideo'; // Remove this line if not needed

const TrainingTrainer = () => {
    return (
        <div className="rn-splite-style">
            <div className="split-wrapper">
                <div className="row no-gutters radius-10 align-items-center">
                    <div className="col-lg-12 col-xl-6 col-12">
                        {/* Replace video with image */}
                        <div className="image-container">
                            <img 
                                src="/images/training-pwu.jpg" 
                                alt="Jahid Hasan" 
                                className="img-fluid rounded"
                            />
                        </div>
                    </div>
                    <div className="col-lg-12 col-xl-6 col-12">
                        <div className="split-inner">
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <h4 className="title">Jahid Hasan</h4>
                            </ScrollAnimation>
                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <p className="description"></p>
                            </ScrollAnimation>

                            <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <p>
                                    Entrepreneur | Investor | Life, Business & Income Strategist | Personal Finance Mentor.
                                </p>
                            </ScrollAnimation>

                            {/* Uncomment if needed */}
                            {/* <ScrollAnimation 
                                animateIn="fadeInUp"
                                animateOut="fadeInOut"
                                animateOnce={true}>
                                <div className="view-more-button mt--35">
                                    <Link className="btn-default" to="/speaker/details">Learn More</Link>
                                </div>
                            </ScrollAnimation> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TrainingTrainer;
